import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import { useLocalStorage } from '@rehooks/local-storage';
import { getInstance as getBootstrap } from 'utils/bootstrap';
import useVEPRequests from '../../hooks/useVEPGuestRequests';
import { useVEPStateMachine } from '../../hooks/useVEPStateMachine';

const bootstrap = getBootstrap();
const eventId = parseInt(bootstrap.get('event.id', null), 10);
const eventDomain = bootstrap.get('event.domain', '');

const initialContextData = {
    settings: {},
    guest: {},
    event: {},
    actions: {},
    tokens: {},
    currentPageState: null,
    isLoading: true,
};
const VirtualEventDataContext = React.createContext(initialContextData);

function redirectToEventPage() {
    const openRegistrationModalParam = 'autoopen=1';

    const params = eventDomain.split('?');

    // check if ?preview is added (local)
    const connector = params.length > 1 ? '&' : '/?';
    window.location.replace(`${eventDomain}${connector}${openRegistrationModalParam}`);
}

export default function VirtualEventAttendeeDataManager({ children }) {
    const [tokens, setTokens] = useLocalStorage(`splashVirtualEvent/${eventId}`);
    const { virtualEventSettings = {}, actions } = useVEPRequests({ onError: redirectToEventPage });

    const isDataLoadedAndNotCheckedIn =
        virtualEventSettings?.settings?.engine?.states && virtualEventSettings?.event && !tokens?.checkInToken;
    const isDataLoadedAndCheckedIn = tokens?.checkInToken && virtualEventSettings?.settings?.embedConfig;

    const isLoading = !(isDataLoadedAndNotCheckedIn || isDataLoadedAndCheckedIn);
    const { currentPageState } = useVEPStateMachine({ enabled: !isLoading, event: virtualEventSettings?.event });

    return (
        <VirtualEventDataContext.Provider
            value={{
                ...virtualEventSettings,
                tokens,
                actions: {
                    checkIn: () => actions.checkIn(),
                    setTokens,
                },
                currentPageState,
                isLoading,
            }}
        >
            {children}
        </VirtualEventDataContext.Provider>
    );
}

VirtualEventAttendeeDataManager.propTypes = {
    children: PropTypes.node.isRequired,
};

export const useVirtualEventAttendeeData = () => useContext(VirtualEventDataContext);
